import type React from 'react'
import type { SumsubTransactionMonitoringStatus } from '../types/coreApi-types'

interface SumsubTransactionMonitoringStatusBadgeProps {
  status: SumsubTransactionMonitoringStatus | null | undefined
}

const SumsubTransactionMonitoringStatusBadge: React.FC<
  SumsubTransactionMonitoringStatusBadgeProps
> = ({ status }) => {
  if (!status) {
    return <div className="status-badge status-badge-neutral">Not Set</div>
  }

  const getClassName = () => {
    switch (status) {
      case 'NotSubmitted':
        return 'status-badge status-badge-neutral'
      case 'Submitted':
        return 'status-badge status-badge-processing'
      case 'Approved':
        return 'status-badge status-badge-success'
      case 'Rejected':
        return 'status-badge status-badge-cancelled'
      case 'OnHold':
        return 'status-badge status-badge-warning'
      case 'AwaitingUser':
        return 'status-badge status-badge-info'
      default:
        return 'status-badge status-badge-neutral'
    }
  }

  const getDisplayText = () => {
    switch (status) {
      case 'NotSubmitted':
        return 'Not Submitted'
      case 'Submitted':
        return 'Submitted'
      case 'Approved':
        return 'Approved'
      case 'Rejected':
        return 'Rejected'
      case 'OnHold':
        return 'On Hold'
      case 'AwaitingUser':
        return 'Awaiting User'
      default:
        return status
    }
  }

  return <div className={getClassName()}>{getDisplayText()}</div>
}

export default SumsubTransactionMonitoringStatusBadge
